import React from 'react';

function Contact() {
  const handleSubmit = (e) => {
    e.preventDefault();
    alert('Thank you for your message! I will get back to you soon.');
    e.target.reset();
  };

  return (
    <section id="contact" className="contact">
      <h2>Get in Touch</h2>
      <div className="contact-content">
        <form id="contact-form" onSubmit={handleSubmit}>
          <input type="text" placeholder="Name" required />
          <input type="email" placeholder="Email" required />
          <textarea placeholder="Message" required></textarea>
          <button type="submit">Send Message</button>
        </form>
        <div className="social-links">
          <a href="https://example.com"><i className="fab fa-twitter"></i></a>
          <a href="https://example.com"><i className="fab fa-linkedin"></i></a>
          <a href="https://example.com"><i className="fab fa-github"></i></a>
        </div>
      </div>
    </section>
  );
}

export default Contact; 